import React, { useEffect } from "react";
import { connect } from "react-redux";
import useRoute from "../../../../helpers/useRoute";
import { Routes } from "../../../../routes";
import { Button, Table } from "@themesberg/react-bootstrap";
import authorization from "../../../../helpers/authorization";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye } from "@fortawesome/free-solid-svg-icons";
import { BeatLoader } from "react-spinners";
import { getAllBanks } from "../../../../actions/partners";

const TableRow = (props) => {
    //
    const {
        index, id, bankCode, address, bankName, bankShort, tinNumber,
        phoneNumber, email, partnerType: code,
    } = props;
    //
    const urlEdit = useRoute(Routes.EditPartner.path, { code, id });
    const urlView = useRoute(Routes.ViewPartner.path, { code, id });

    return (
        <tr valign="middle">
            <td className="text-center">
                <span className="text-primary fw-bold">{index}</span>
            </td>
            <td className="fw-bold text-center">
                <a href={authorization("PA_BROWSE") ? `${urlView}` : "#"} className="text-decoration-none">
                    {bankName}
                </a>
            </td>
            <td className="text-center">{bankCode}</td>
            <td className="text-center">{bankShort}</td>
            <td className="text-center">{phoneNumber}</td>
            <td className="text-center">{tinNumber}</td>
            <td className="text-center">{address}</td>
            <td className="text-center">{email}</td>
            <td className="text-center">
                <div className="d-flex justify-content-center gap-2">
                    {
                        authorization("PA_EDIT") && (
                            <Button variant="light" size="sm" href={urlEdit} title="Edit">
                                <FontAwesomeIcon icon={faEdit} className="icon icon-xs text-success" />
                            </Button>
                        )
                    }
                    <Button 
                        variant="light"
                        size="sm" 
                        disabled={!authorization("PA_BROWSE")}
                        href={urlView}
                        title="View"
                    >
                        <FontAwesomeIcon icon={faEye} className="icon icon-xs text-info" />
                    </Button>
                </div>
            </td>
        </tr>
    );
};

const BrowseBanks = (props) => {

    const { banks, error, getAllBanks, partnerType, freelancerLoading: loading } = props;
    useEffect(() => {
        if (banks == null && !loading) {
            getAllBanks();
        }
    }, [banks, error, loading,]);

    const urlAddBank = useRoute(Routes.AddPartner.path, { code: partnerType });

    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
                <Button
                    variant="primary"
                    href={urlAddBank}
                    disabled={!authorization("PA_CREATE")}
                    className="mb-2 mb-md-0"
                >
                    Add New Bank
                </Button>
            </div>
            <div className="table-responsive">
                <Table striped className="table-centered table-bordered table-nowrap rounded mb-0">
                    <thead className="thead-light">
                        <tr>
                            <th className="text-center">#</th>
                            <th className="text-center">Bank Name</th>
                            <th className="text-center">Bank Code</th>
                            <th className="text-center">Bank Short</th>
                            <th className="text-center">Phone Number</th>
                            <th className="text-center">Tin Number</th>
                            <th className="text-center">Address</th>
                            <th className="text-center">Email</th>
                            <th className="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            loading ? (
                                <tr>
                                    <td colSpan="9" align="center" className="py-4">
                                        <BeatLoader color="#262B40" size="8" />
                                    </td>
                                </tr>
                            ) : banks != null && banks.length > 0 ?
                                banks.map((partner, i) => <TableRow {...partner}
                                    index={++i}
                                    partnerType={partnerType}
                                    key={`page-visit-${partner.id}`} />) : (
                                    <tr>
                                        <td colSpan="9" align="center" className="py-4 text-muted">
                                            <div className="d-flex flex-column align-items-center">
                                                <p className="mb-0">No banks available</p>
                                            </div>
                                        </td>
                                    </tr>
                                )
                        }
                    </tbody>
                </Table>
            </div>
        </>
    );
}
const mapStateToProps = (store) => {
    const { error, banks, freelancerLoading } = store.partners;
    return { error, banks, freelancerLoading };
}
export default connect(mapStateToProps, { getAllBanks })(BrowseBanks);
